/* eslint-disable */
import React from 'react';
import { AlertTriangle, Globe } from 'lucide-react';
import { getCentralPlatformUrl } from '../../utils/tenant';
import './NotFound.css';

export default function TenantNotFound({ slug }) {
    const centralUrl = getCentralPlatformUrl();

    return (
        <div
            className="notfound-container"
            style={{
                minHeight: '100vh',
                backgroundColor: '#f8fafc',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '24px',
            }}
        >
            <div
                className="notfound-card"
                style={{
                    maxWidth: '520px',
                    width: '100%',
                    padding: '48px 36px',
                    backgroundColor: '#ffffff',
                    borderRadius: '16px',
                    boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.08), 0 8px 10px -6px rgba(0, 0, 0, 0.04)',
                    border: '1px solid #e2e8f0',
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <div
                    style={{
                        backgroundColor: 'rgba(239, 68, 68, 0.1)',
                        width: '72px',
                        height: '72px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: '20px',
                    }}
                >
                    <AlertTriangle style={{ width: '38px', height: '38px', color: '#ef4444' }} />
                </div>

                <h1
                    style={{
                        fontSize: '1.75rem',
                        fontWeight: 700,
                        color: '#0f172a',
                        marginBottom: '10px',
                        letterSpacing: '-0.4px',
                    }}
                >
                    Organisation Not Found
                </h1>

                <p
                    style={{
                        color: '#64748b',
                        fontSize: '0.95rem',
                        lineHeight: 1.6,
                        margin: '0 0 28px 0',
                    }}
                >
                    The organisation subdomain{' '}
                    <strong style={{ color: '#0f172a', fontWeight: 600 }}>
                        {slug ? `"${slug}"` : 'you requested'}
                    </strong>{' '}
                    does not exist on <i>my</i>Academic or has been deactivated. This website cannot be accessed.
                </p>

                <a
                    href={centralUrl}
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                        backgroundColor: '#0055A2',
                        color: '#ffffff',
                        textDecoration: 'none',
                        padding: '12px 24px',
                        borderRadius: '8px',
                        fontWeight: 600,
                        fontSize: '0.925rem',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 2px 4px rgba(0, 85, 162, 0.2)',
                    }}
                    onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = '#00407a';
                        e.currentTarget.style.transform = 'translateY(-1px)';
                    }}
                    onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = '#0055A2';
                        e.currentTarget.style.transform = 'translateY(0)';
                    }}
                >
                    <Globe style={{ width: '18px', height: '18px' }} />
                    <span>Go to Central myAcademic Platform</span>
                </a>
            </div>
        </div>
    );
}

